import React from "react";
const Footer = () => React.createElement(React.Fragment, null);
export { Footer };
